module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/crm-central-place/crm-central-place@2x.svg"